import { render, staticRenderFns } from "./ta_project_details1.vue?vue&type=template&id=63f0d440&scoped=true&"
import script from "./ta_project_details1.vue?vue&type=script&lang=js&"
export * from "./ta_project_details1.vue?vue&type=script&lang=js&"
import style0 from "./ta_project_details1.vue?vue&type=style&index=0&id=63f0d440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f0d440",
  null
  
)

export default component.exports